<template>
  <div>
  <b-card class="addon">
    <div class="mx-50 d-flex justify-content-between align-items-center">
      <!-- Filters title -->
      <h3>
        {{ $t("media.filters.action.filter") }}
      </h3>

      <!-- Toggle filters button -->
      <b-button
        v-if="hasClassifiers"
        variant="primary"
        size="sm"
        class="d-lg-none"
        @click="toggleFilters"
      >
        Toggle
      </b-button>
    </div>
    
    <!-- Filters content -->
    <div
      v-if="hasClassifiers"
      class="filters-container mb-2 px-50 pt-1"
      :class="areFiltersVisible ? 'd-flex flex-column' : 'd-none d-lg-flex flex-column'"
    >
      <!-- Filters -->
      <b-form-group
        v-for="classifierType in classifiersTree"
        :key="classifierType.key"
        :label="translateLabel(classifierType.name)"
        :label-for="`classifier-filter-${classifierType.key}`"
        class="w-100"
      >
        <v-select
          v-model="selectedClassifiersForFilter[classifierType.key]"
          :name="`classifier-filter-${classifierType.key}`"
          clearable
          :searchable="false"
          label="name"
          placeholder="Select..."
          :reduce="(a) => a"
          return-object
          :options="filterOptions(classifierType)"
          @input="onFilterChange"
        />
      </b-form-group>
      
      <!-- Filter logic -->
      <b-form-group
        :label="$t('filters.logic')"
        label-for="filterLogicLabel"
        class="w-100"
      >
        <v-select
          name="filterLogicLabel"
          v-model="filterLogic"
          :searchable="false"
          :clearable="false"
          label="name"
          :reduce="(a) => a"
          return-object
          placeholder="Select..."
          :options="orAndOptions"
        />
      </b-form-group>
      
      <!-- Search button -->
      <b-button
        variant="primary"
        type="submit"
        @click.prevent="handleSearch"
      >
        SEARCH
      </b-button>
    </div>
    
    <!-- No filters available -->
    <div
      v-else-if="!hasClassifiers"
      class="horizontal-placeholder d-block h-100 media-placeholder"
    >
      <div class="text-center">
        <img :src="placeholderFilter" />
        <p class="text-primary mt-2">
          {{ $t("available.message", { itemName: $t("media.filters.action.filter") }) }}
        </p>
        <p class="text-muted small mt-1">
          Loading...
        </p>
      </div>
    </div>
  </b-card>
  </div>
</template>

<script>
import { translateTranslationTable } from "@/@core/libs/i18n/utils";
import vSelect from "vue-select";
import FilterPlaceholder from "@/assets/images/placeholders/light/filters.svg";

export default {
  name: "Filter",
  components: {
    vSelect,
  },
  props: {
    classifiersTree: {
      type: Array,
      default: () => [],
    },
    currentLocale: {
      type: String,
      default: 'en',
    },
    selectedClassifiersForFilter: {
      type: Object,
      default: () => ({}),
    },
    filterLogic: {
      type: Object,
      default: () => ({ name: "AND", value: "AND" }),
    },
    areFiltersVisible: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    // Component created
    console.log('Filter component created');
    console.log('classifiersTree prop:', this.classifiersTree);
    console.log('classifiersTree length:', this.classifiersTree.length);
    console.log('currentLocale prop:', this.currentLocale);
    console.log('selectedClassifiersForFilter prop:', this.selectedClassifiersForFilter);
    console.log('filterLogic prop:', this.filterLogic);
    console.log('areFiltersVisible prop:', this.areFiltersVisible);
  },
  watch: {
    classifiersTree: {
      handler(newValue) {
        console.log('Filter component - classifiersTree changed:', newValue);
        console.log('Filter component - classifiersTree length:', newValue.length);
        console.log('Filter component - hasClassifiers will be:', newValue.length > 0);
        // Force re-evaluation of computed properties
        this.$forceUpdate();
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    placeholderFilter() {
      return FilterPlaceholder;
    },
    orAndOptions() {
      return [
        { name: this.$t("AND"), value: "AND" },
        { name: this.$t("OR"), value: "OR" }
      ];
    },
    hasClassifiers() {
      console.log('Filter component - hasClassifiers computed:', this.classifiersTree.length > 0);
      console.log('Filter component - classifiersTree data:', this.classifiersTree);
      return this.classifiersTree.length > 0;
    }
  },

  methods: {
    filterOptions(classifierType) {
      let translatedClassifiers = [];
      if (classifierType && classifierType.classifiers && Array.isArray(classifierType.classifiers)) {
        for(let classifier of classifierType.classifiers){
          translatedClassifiers.push({
            name: this.translateTranslationTable(this.currentLocale, classifier.name),
            typeKey: classifierType.key,
            key: classifier.key,
            type: 1,
          });
        }
      }
      return translatedClassifiers;
    },
    toggleFilters() {
      this.$emit('toggle-filters');
    },
    onFilterChange() {
      console.log('Filter component - onFilterChange called');
      console.log('Filter component - selectedClassifiersForFilter:', this.selectedClassifiersForFilter);
      this.$emit('update:selectedClassifiersForFilter', this.selectedClassifiersForFilter);
      this.$emit('set-selected-final-filter');
    },
    setSelectedFinalFilter() {
      this.$emit('set-selected-final-filter');
    },
    handleSearch() {
      this.$emit('search');
    },
    translateTranslationTable,
    translateLabel(label) {
      if (label) {
        return this.translateTranslationTable(this.currentLocale, label);
      }
      return '';
    }
  },
};
</script>

<style lang="scss" scoped>
.addon {
  background-color: white !important;
  border-radius: 12px !important;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1) !important;
  border: 1px solid #e8e8e8 !important;
  padding: 1rem !important;
  margin-bottom: 1rem !important;
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  min-height: 200px !important;
  width: 100% !important;
}

.card {
  background-color: white !important;
  border-radius: 12px !important;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1) !important;
  border: 1px solid #e8e8e8 !important;
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  min-height: 200px !important;
  width: 100% !important;
}

.filters-container {
  display: flex !important;
  flex-direction: column !important;
  gap: 1rem !important;
  visibility: visible !important;
  opacity: 1 !important;
}

.media-placeholder {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  
  img {
    width: 100%;
    max-width: 160px;
    display: block !important;
    margin: 0 auto !important;
  }
}

.horizontal-placeholder {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  text-align: center !important;
}

@import "~@core/scss/base/bootstrap-include";
@include media-breakpoint-up(lg) {
  .addon {
    min-height: 44vh;
  }
}
</style> 